var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ssoContent" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "ssoContentRight" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ssoContentLeft" }, [
      _c("div", { staticClass: "content_item" }, [
        _c("img", { attrs: { src: require("./images/msg.png") } }),
        _vm._v(" "),
        _c("div", { staticClass: "content_msg" }, [
          _c("div", { staticClass: "content_title" }, [
            _vm._v("\n                    即时资讯 精选评论\n                ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content_detail" }, [
            _vm._v(
              "\n                    汇集全球热门金融资讯，快速了解市场行情。\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content_item" }, [
        _c("img", { attrs: { src: require("./images/master.png") } }),
        _vm._v(" "),
        _c("div", { staticClass: "content_msg" }, [
          _c("div", { staticClass: "content_title" }, [
            _vm._v("\n                    名师汇聚一堂\n                ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content_detail" }, [
            _vm._v(
              "\n                    专家专业解读，在线答疑解惑。\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content_item" }, [
        _c("img", { attrs: { src: require("./images/econ.png") } }),
        _vm._v(" "),
        _c("div", { staticClass: "content_msg" }, [
          _c("div", { staticClass: "content_title" }, [
            _vm._v(
              "\n                    一站式企业汇率风险管理平台\n                "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content_detail" }, [
            _vm._v(
              "\n                    满足企业对汇率风险管理的多元化需求，实现企业高效、稳健、可持续的发展。\n                "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14fbdead", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14fbdead","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sso/components/content/content.vue
// module id = 444
// module chunks = 0